<mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="tabChanged($event)">
  <!-- Proposer Tab -->
  <mat-tab>
    <ng-template mat-tab-label>
      Proposer
    </ng-template>
    <div class="card-body">
      <app-sdtk-proposer-details [staticData]="staticData" [apiModelObject]="apiModelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"></app-sdtk-proposer-details>
    </div>
  </mat-tab>
  <mat-tab [disabled]="unlockedTabIndex < 1 || quote_type == 4">
    <ng-template mat-tab-label>
      Cover Details
    </ng-template>
    <div class="card-body">
      <app-sdtk-vehicles [staticData]="staticData" [apiModelObject]="apiModelObject" [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"></app-sdtk-vehicles>
    </div>
  </mat-tab>
  <mat-tab [disabled]="unlockedTabIndex < 2 || quote_type == 4">
    <ng-template mat-tab-label>
      Quotation
    </ng-template>
    <div class="card-body">
      <app-sdtk-quotation (back)="onBackFromQuotation($event)" [staticData]="staticData" [apiModelObject]="apiModelObject" [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"></app-sdtk-quotation>
    </div>
  </mat-tab>
</mat-tab-group>